/**
 * Default campaign per country — localStorage cache.
 * For Media Devoted | Created By Ciro Autiero
 */

const KEY_PREFIX = 'trafficpulse:smswiser:default-campaign';

function storageKey(countryKey: string): string {
  return `${KEY_PREFIX}:${countryKey}`;
}

export function getDefaultCampaign(countryKey: string): number | null {
  if (!countryKey?.trim()) return null;
  try {
    const raw = localStorage.getItem(storageKey(countryKey));
    if (!raw) return null;
    const n = Number(raw);
    return Number.isFinite(n) && n > 0 ? n : null;
  } catch {
    return null;
  }
}

export function setDefaultCampaign(countryKey: string, campaignId: number): void {
  if (!countryKey?.trim() || !Number.isFinite(campaignId) || campaignId <= 0) return;
  try {
    localStorage.setItem(storageKey(countryKey), String(campaignId));
  } catch {
    // ignore
  }
}
